import { generatePath } from "react-router";

import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { SettingsSiteControllerContainer } from "@/components/features/settings/site-controller/ui";

import { useConfirmParams } from "./hooks";

export const SettingsSiteControllerPage = () => {
	const result = useConfirmParams();

	const { canRender } = result;
	if (!canRender) return <></>;

	const { hotelID } = result;

	return (
		<PageMeta title="サイコンの設定" url={generatePath(PATHS.SETTINGS.SITE_CONTROLLER, { hotelID })}>
			<SettingsSiteControllerContainer hotelID={hotelID} />
		</PageMeta>
	);
};

SettingsSiteControllerPage.displayName = "SettingsSiteControllerPage";
